// // const target = document.querySelector('.collection-featured-block--secondary');
// // const glowSection = document.querySelector('.glow-pass-rewards-section');

// // target.insertAdjacentElement('afterbegin', glowSection);


// // const target2 = document.querySelector('.collection-promo-banner--primary');
// // const skin_type_custom = document.querySelector('.skin_type_custom');

// // target2.insertAdjacentElement('afterbegin', skin_type_custom);


//Here starts the dom practise

// (function() {
//   if (!window.location.pathname.includes('/collections')) {
//     return;
//   }
  
//   const skinTypeCustom = document.querySelector('.skin_type_custom');
//   const glowSection = document.querySelector('.glow-pass-rewards-section');
  
//   if (!skinTypeCustom && !glowSection) {
//     console.log('No elements found');
//     return;
//   }
  
//   const safeContainer = document.createElement('div');
//   safeContainer.id = 'safe-storage';
//   safeContainer.style.display = 'none';
//   document.body.appendChild(safeContainer);
  
//   if (skinTypeCustom) {
//     safeContainer.appendChild(skinTypeCustom);
//     console.log('skinTypeCustom stored safely');
//   }
  
//   if (glowSection) {
//     safeContainer.appendChild(glowSection);
//     console.log('glowSection stored safely');
//   }
  
//   let isMoving = false;
  
//   function moveToSafety() {
//     if (isMoving) return;
    
//     const skinElement = document.querySelector('.collection-promo-banner--primary .skin_type_custom');
//     if (skinElement) {
//       isMoving = true;
//       safeContainer.appendChild(skinElement);
//       console.log('skinTypeCustom moved to safety');
//     }
    
//     const glowElement = document.querySelector('.collection-featured-block--secondary .glow-pass-rewards-section');
//     if (glowElement) {
//       isMoving = true;
//       safeContainer.appendChild(glowElement);
//       console.log('glowSection moved to safety');
//     }
//   }
  
//   function injectElements() {
//     const target1 = document.querySelector('.collection-promo-banner--primary');
//     const alreadyExists1 = target1?.querySelector('.skin_type_custom');
//     const storedSkin = safeContainer.querySelector('.skin_type_custom');
    
//     if (target1 && storedSkin && !alreadyExists1) {
//       target1.insertAdjacentElement('afterbegin', storedSkin);
//       console.log('skinTypeCustom injected!');
//     }
    
//     const target2 = document.querySelector('.collection-featured-block--secondary');
//     const alreadyExists2 = target2?.querySelector('.glow-pass-rewards-section');
//     const storedGlow = safeContainer.querySelector('.glow-pass-rewards-section');
    
//     if (target2 && storedGlow && !alreadyExists2) {
//       target2.insertAdjacentElement('afterbegin', storedGlow);
//       console.log('glowSection injected!');
//     }
    
//     isMoving = false;
//   }
  
//   injectElements();
  
//   function isFilterRequest(url) {
//     const urlStr = url?.toString() || '';
//     return urlStr.includes('filter') || 
//            urlStr.includes('sort') || 
//            urlStr.includes('page') ||
//            urlStr.includes('collection');
//   }
  
//   const originalFetch = window.fetch;
//   window.fetch = function(...args) {
//     if (isFilterRequest(args[0])) {
//       moveToSafety();
//       return originalFetch.apply(this, args).then(response => {
//         setTimeout(injectElements, 300);
//         return response;
//       });
//     }
//     return originalFetch.apply(this, args);
//   };
  
//   const originalXHROpen = XMLHttpRequest.prototype.open;
//   const originalXHRSend = XMLHttpRequest.prototype.send;
  
//   XMLHttpRequest.prototype.open = function(method, url) {
//     this._url = url;
//     return originalXHROpen.apply(this, arguments);
//   };
  
//   XMLHttpRequest.prototype.send = function(...args) {
//     if (isFilterRequest(this._url)) {
//       moveToSafety();
//       this.addEventListener('load', function() {
//         setTimeout(injectElements, 300);
//       });
//     }
//     return originalXHRSend.apply(this, args);
//   };
  
//   console.log('Setup complete for both elements');
// })();




//Working approach
(function() {
  if (!window.location.pathname.includes('/collections')) {
    return;
  }
  
  function init() {
    const skinTypeCustom = document.querySelector('.skin_type_custom');
    const glowSection = document.querySelector('.glow-pass-rewards-section');
    
    if (!skinTypeCustom && !glowSection) {
      console.log('No elements found');
      return;
    }
    
    if (document.getElementById('safe-storage')) {
      return;
    }
    
    const safeContainer = document.createElement('div');
    safeContainer.id = 'safe-storage';
    safeContainer.style.display = 'none';
    document.body.appendChild(safeContainer);
    
    if (skinTypeCustom) {
      safeContainer.appendChild(skinTypeCustom);
      console.log('skinTypeCustom stored safely');
    }
    
    if (glowSection) {
      safeContainer.appendChild(glowSection);
      console.log('glowSection stored safely');
    }
    
    function moveToSafety() {
      const skinElement = document.querySelector('.collection-promo-banner--primary .skin_type_custom');
      if (skinElement) {
        safeContainer.appendChild(skinElement);
        console.log('skinTypeCustom moved to safety');
      }
      
      const glowElement = document.querySelector('.collection-featured-block--secondary .glow-pass-rewards-section');
      if (glowElement) {
        safeContainer.appendChild(glowElement);
        console.log('glowSection moved to safety');
      }
    }
    
    function injectElements() {
      const target1 = document.querySelector('.collection-promo-banner--primary');
      const alreadyExists1 = target1?.querySelector('.skin_type_custom');
      const storedSkin = safeContainer.querySelector('.skin_type_custom');
      
      if (target1 && storedSkin && !alreadyExists1) {
        target1.insertAdjacentElement('afterbegin', storedSkin);
        console.log('skinTypeCustom injected!');
      }
      
      const target2 = document.querySelector('.collection-featured-block--secondary');
      const alreadyExists2 = target2?.querySelector('.glow-pass-rewards-section');
      const storedGlow = safeContainer.querySelector('.glow-pass-rewards-section');
      
      if (target2 && storedGlow && !alreadyExists2) {
        target2.insertAdjacentElement('afterbegin', storedGlow);
        console.log('glowSection injected!');
      }
    }
    
    function waitForTargetsAndInject() {
      const target1 = document.querySelector('.collection-promo-banner--primary');
      const target2 = document.querySelector('.collection-featured-block--secondary');
      
      if (target1 || target2) {
        injectElements();
      } else {
        setTimeout(waitForTargetsAndInject, 100);
      }
    }
    
    waitForTargetsAndInject();
    
    // Watch for collection__loading.is-active
    const observer = new MutationObserver(function(mutations) {
      const loader = document.querySelector('.collection__loading');
      
      if (loader && loader.classList.contains('is-active')) {
        console.log('Loading started - move to safety');
        moveToSafety();
      }
      
      if (loader && !loader.classList.contains('is-active')) {
        console.log('Loading finished - inject');
        setTimeout(injectElements, 200);
      }
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    console.log('Setup complete - watching for collection__loading');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


//Here ends the dom practise